import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { TermsAgreementModalProps } from './types';
import { useTermsAgreementModal } from './useTermsAgreementModal';
import './TermsAgreementModal.css';

export const TermsAgreementModal: React.FC<TermsAgreementModalProps> = ({
  isOpen,
  onAgree,
  onDecline,
}) => {
  const {
    terms,
    loading,
    agreeing,
    error,
    handleAgree,
    handleOverlayClick,
  } = useTermsAgreementModal({ isOpen, onAgree });

  if (!isOpen) return null;

  return (
    <div className="terms-modal-overlay" onClick={handleOverlayClick}>
      <div className="terms-modal-content">
        <div className="terms-modal-header">
          <h2 className="terms-modal-title">利用規約</h2>
          {terms && (
            <p className="terms-modal-version-info">
              バージョン {terms.version} | 施行日: {new Date(terms.effective_date).toLocaleDateString('ja-JP')}
            </p>
          )}
        </div>

        <div className="terms-modal-content-container">
          {loading && <div className="terms-loading-spinner" />}
          
          {error && <div className="terms-error-message">{error}</div>}
          
          {terms && !loading && (
            <div className="terms-content">
              <ReactMarkdown 
                remarkPlugins={[remarkGfm]}
                components={{
                  // リンクを新しいタブで開く
                  a: ({ node, ...props }) => (
                    <a {...props} target="_blank" rel="noopener noreferrer" />
                  ),
                }}
              >
                {terms.content}
              </ReactMarkdown>
            </div>
          )}
        </div>

        <div className="terms-modal-footer">
          <button 
            className="terms-modal-button terms-modal-button--secondary"
            onClick={onDecline}
            disabled={agreeing}
          >
            同意しない
          </button>
          <button 
            className="terms-modal-button terms-modal-button--primary"
            onClick={handleAgree}
            disabled={loading || agreeing || !terms}
          >
            {agreeing ? '処理中...' : '同意する'}
          </button>
        </div>
      </div>
    </div>
  );
};